import { QRCodeCanvas } from 'qrcode.react'
import style from '../style/components/qrcode.module.scss'

interface QRcodeProps {
  url: string
  size?: number
}

const QRcode = ({ url, size = 224 }: QRcodeProps) => {
  return (
    <div className={`${style.wrapper} ${style['with-background']}`}>
      <QRCodeCanvas value={url} size={size} />
    </div>
  )
}

export default QRcode
